import gql from 'graphql-tag';

export default gql`
  query($slug: String) {
    getShop(slug: $slug) {
      id
      slug
      type
      name
      ttPhone
      ttHours
      imgDesk
      logo1Desk
      logo1Mob
      logo2Desk
      logo2Mob
      importantDesk
      importantMob
      headerDesk
      headerMob
      is_new
      is_heart
      category {
        id
        detail {
          label
          slug
        }
      }
      socialNetworks {
        name
        url
      }
      blocks
      detail {
        title
        content
        ctaLabel
        ctaUrl
        ttTexte
        ttCtaUrl
        ttCtaLabel
        importantTexte
        importantCtaUrl
        importantCtaLabel
      }
      place {
        id
        name
        label
        slug
        type
        area
        floor
        floors
        image
        building
      }
    }
  }
`;
